import { Question } from "@secureo/common/machines/productAdvisorMachine"

// Todo: replace PATH with path to SVG files

import BasisBrandEinbruchschutz from "svg/advisor/basis-brand-einbruchschutz.svg"
import Brandschutz from "svg/advisor/brandschutz.svg"
import BasisBrandschutz from "svg/advisor/basisbrandschutz.svg"
import BasisSchutz from "svg/advisor/basisschutz.svg"
import Betäubungsmittel from "svg/advisor/betaeubungsmittel.svg"
import Bodentresor from "svg/advisor/bodentresor.svg"
import Datenträger from "svg/advisor/datenträger.svg"
import Doppelbartschloss from "svg/advisor/doppelbartschloss.svg"
import EinbruchBrandschutz from "svg/advisor/einbruch-brandschutz.svg"
import Einbruchschutz from "svg/advisor/einbruchschutz.svg"
import Fingerprint from "svg/advisor/fingerprint.svg"
import Freistehend from "svg/advisor/freistehend.svg"
import GuterBrandEinbruchschutz from "svg/advisor/guter-brand-einbruchschutz.svg"
import GuterBrandschutz from "svg/advisor/guter-brandschutz.svg"
import GuterSchutz from "svg/advisor/guter-schutz.svg"
import Kurzwaffen from "svg/advisor/kurzwaffen.svg"
import LangKurzWaffen from "svg/advisor/lang_kurz-waffen.svg"
import Mechanisch from "svg/advisor/mechanisch.svg"
import Moebeltresor from "svg/advisor/moebeltresor.svg"
import Munition from "svg/advisor/munition.svg"
import PremiumBrandEinbruchschutz from "svg/advisor/premium-brand-einbruchschutz.svg"
import PremiumBrandschutz from "svg/advisor/premium-brandschutz.svg"
import PremiumSchutz from "svg/advisor/premiumschutz.svg"
import Schluessel from "svg/advisor/schluessel.svg"
import Schluesselkaesten from "svg/advisor/schluesselkaesten.svg"
import Schluesselmanagement from "svg/advisor/schluesselmgnt.svg"
import Schluesseltresore from "svg/advisor/schluesseltresore.svg"
import WaffenMunition from "svg/advisor/waffen-munition.svg"
import Wandtresor from "svg/advisor/wandtresor.svg"
import Wertgegenstände from "svg/advisor/wertgegenstaende.svg"
import Zahlenschloss from "svg/advisor/zahlenschloss.svg"

const questionsByQuestionId: { [key: string]: Omit<Question, "id"> } = {
	root: {
		label: "Was möchten Sie schützen?",
		answers: [
			{
				label: "Wertgegenstände und Dokumente",
				icon: Wertgegenstände,
				description:
					"Aufbewahrung und Sicherung diverser Wertgegenstände, Bargeld und Dokumente vor Einbruch und/oder Feuer.",
				searchState: {
					// range: {
					// 	schlüsselhaken: {
					// 		min: 10,
					// 		max: 1000,
					// 	},
					// },
					refinementList: {
						categoryIds: ["tre-einbruchsichere-tresore", "tre-feuerfeste-tresore"],
					},
				},
				nextQuestionId: "safeType",
			},
			{
				label: "Waffen und Munition",
				icon: WaffenMunition,
				description:
					"Gesetzeskonforme Aufbewahrung von Langwaffen wie Gewehre oder Flinten, Kurzwaffen oder Munition.",
				searchState: {
					refinementList: {},
				},
				nextQuestionId: "weaponType",
			},
			{
				label: "Datenträger",
				icon: Datenträger,
				description:
					"Feuersichere Aufbewahrung von optischen oder magnetischen Datenträgern und Speichermedien.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-datentresore"],
					},
				},
				nextQuestionId: "dataFireProtectionType",
			},
			{
				label: "Schlüssel",
				icon: Schluessel,
				description: "Übersichtliche Verwahrung, Sicherung und Verwaltung von Schlüsseln.",
				searchState: {
					refinementList: {},
				},
				nextQuestionId: "keySafeType",
			},
			{
				label: "Betäubungsmittel",
				icon: Betäubungsmittel,
				description:
					"Gesetzeskonforme und übersichtliche Aufbewahrung von Arznei- und Betäubungsmitteln.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-btm-tresore"],
					},
				},
				nextQuestionId: "lockType",
				//nextQuestionId: "shelfOrDrawer",
			},
		],
	},
	safeType: {
		label: "Welche Art von Tresor benötigen Sie?",
		answers: [
			{
				label: "freihstehender Tresor",
				icon: Freistehend,
				description: "Der Tresor wird freistehend am Fußboden oder einer Wand verankert.",
				searchState: {
					refinementList: {
						safeType: ["Wertschutzschränke"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "protectionType",
			},
			{
				label: "Möbeltresor",
				icon: Moebeltresor,
				description: "Der Tresor wird in ein Möbelstück eingebaut.",
				searchState: {
					refinementList: {
						safeType: ["Wertschutzschränke"],
						positionOfHinges: ["inside"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "protectionType",
			},
			{
				label: "Wandtresor",
				icon: Wandtresor,
				description: "Der Tresor wird in eine Wand einbetoniert.",
				searchState: {
					refinementList: {
						safeType: ["Wandtresore"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "valueProtectionCertified",
			},
			{
				label: "Bodentresor",
				icon: Bodentresor,
				description: "Der Tresor wird in den Boden einbetoniert.",
				searchState: {
					refinementList: {
						safeType: ["Bodentresore"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "valueProtectionCertified",
			},
		],
	},
	protectionType: {
		label: "Welchen Schutz soll Ihr neuer Tresor bieten?",
		answers: [
			{
				label: "Einbruchschutz",
				icon: Einbruchschutz,
				description: "Reiner Schutz vor Einbruchsversuchen.",
				searchState: {},
				nextQuestionId: "valueProtectionType",
			},
			{
				label: "Brandschutz",
				icon: Brandschutz,
				description: "Reiner Schutz vor Flammen und Hitze.",
				searchState: {},
				nextQuestionId: "fireProtectionType",
			},
			{
				label: "Einbruch- und Brandschutz",
				icon: EinbruchBrandschutz,
				description: "Kombinierter Schutz vor Einbruchsversuchen und Bränden.",
				searchState: {},
				nextQuestionId: "valueAndFireProtectionType",
			},
		],
	},
	valueAndFireProtectionType: {
		label: "Welchen Schutz soll Ihr neuer Tresor bieten?",
		answers: [
			{
				label: "Basis Einbruch- und Brandschutz",
				icon: BasisBrandEinbruchschutz,
				description:
					"Der Tresor wird nicht versichert, bietet aber Schutz vor Flammen, Hitze und umherfliegenden Glutpartikeln bei leichten Bränden.",
				searchState: {
					refinementList: {
						securityGrade: ["S1 nach EN 14450", "S2 nach EN 14450", "0 nach EN 1143-1"],
						fireSafetyGrade: ["30 Minuten Papier"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Guter Einbruch- und Brandschutz",
				icon: GuterBrandEinbruchschutz,
				description:
					"Versicherungssummen: privat bis max. € 100.000 | gewerblich bis max. € 50.000. Zusätzlich mit zertifiziertem Schutz vor Vollbränden und starker Hitzeeinwirkung.",
				searchState: {
					refinementList: {
						securityGrade: ["1 nach EN 1143-1", "2 nach EN 1143-1"],
						fireSafetyGrade: [
							"60 Minuten Papier",
							"90 Minuten Papier",
							"120 Minuten Papier",
						],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Sehr guter Einbruch- und Brandschutz",
				icon: PremiumBrandEinbruchschutz,
				description:
					"Versicherungssummen: privat bis max. € 1.000.000 | gewerblich bis max. € 500.000. Zusätzlich mit zertifiziertem Schutz vor Vollbränden und starker Hitzeeinwirkung.",
				searchState: {
					refinementList: {
						securityGrade: [
							"3 nach EN 1143-1",
							"4 nach EN 1143-1",
							"4KB nach EN 1143-1",
							"5 nach EN 1143-1",
							"5KB nach EN 1143-1",
							"6 nach EN 1143-1",
						],
						fireSafetyGrade: [
							"60 Minuten Papier",
							"90 Minuten Papier",
							"120 Minuten Papier",
						],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	valueProtectionType: {
		label: "Welchen Schutz soll Ihr neuer Tresor bieten?",
		answers: [
			{
				label: "Basis Einbruchschutz",
				icon: BasisSchutz,
				description:
					"Versicherungssummen: privat bis zu € 40.000 Euro | gewerblich bis zu € 10.000.",
				searchState: {
					refinementList: {
						securityGrade: [
							"A nach VDMA 24992",
							"B nach VDMA 24992",
							"S1 nach EN 14450",
							"S2 nach EN 14450",
							"0 nach EN 1143-1",
						],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Guter Einbruchschutz",
				icon: GuterSchutz,
				description:
					"Versicherungssummen: privat bis zu € 100.000 | gewerblich bis zu € 50.000.",
				searchState: {
					refinementList: {
						securityGrade: ["0 nach EN 1143-1", "1 nach EN 1143-1", "2 nach EN 1143-1"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Sehr guter Einbruchschutz",
				icon: PremiumSchutz,
				description:
					"Versicherungssummen: privat bis zu € 1.000.000 | gewerblich bis zu € 500.000.",
				searchState: {
					refinementList: {
						securityGrade: [
							"3 nach EN 1143-1",
							"4 nach EN 1143-1",
							"4KB nach EN 1143-1",
							"5 nach EN 1143-1",
							"5KB nach EN 1143-1",
							"6 nach EN 1143-1",
						],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	fireProtectionType: {
		label: "Welchen Schutz soll Ihr neuer Tresor bieten?",
		answers: [
			{
				label: "Basis Brandschutz",
				icon: BasisBrandschutz,
				description:
					"Schutz bei leichten Bränden vor Flammen, mäßiger Hitze und umherfliegenden Glutpartikeln.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["30 Minuten Papier"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Guter Brandschutz",
				icon: GuterBrandschutz,
				description: "Zertifizierter Schutz vor Vollbränden und starker Hitzeeinwirkung.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["60 Minuten Papier", "90 Minuten Papier"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Sehr guter Brandschutz",
				icon: PremiumBrandschutz,
				description:
					"Zertifizierter Schutz vor Vollbränden und starker Hitzeeinwirkung über lange Zeit.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["120 Minuten Papier"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	lockType: {
		label: "Mit welcher Art von Schloss wollen Sie Ihren Tresor schließen?",
		answers: [
			{
				label: "Schlüsselschloss",
				icon: Doppelbartschloss,
				description: "Bedienen Sie Ihren Tresor herkömmlich mit einem Schlüssel.",
				searchState: {
					menu: {
						lockType: "Schlüsselschloss",
					},
				},
				nextQuestionId: null,
			},
			{
				label: "Mechanisches Zahlenschloss",
				icon: Mechanisch,
				description:
					"Bedienen Sie Ihren Tresor mit einem Zahlencode, eingegeben über ein mechanisches und batterieloses Dreh-Kombinationsschloss.",
				searchState: {
					menu: {
						lockType: "Mechanisches Kombinationsschloss",
					},
				},
				nextQuestionId: null,
			},
			{
				label: "Elektronikschloss",
				icon: Zahlenschloss,
				description:
					"Bedienen Sie Ihren Tresor mit einem oder mehreren Zahlencodes - einfach und flexibel elektronisch programmierbar.",
				searchState: {
					menu: {
						lockType: "Elektronikschloss",
					},
				},
				nextQuestionId: null,
			},
			{
				label: "Fingerprint",
				icon: Fingerprint,
				description:
					"Bedienen Sie Ihren Tresor bequem per Fingerabdruck (Achtung: häufig zusätzliche PIN-Code Eingabe erforderlich).",
				searchState: {
					menu: {
						lockType: "Fingerprintschloss",
					},
				},
				nextQuestionId: null,
			},
		],
	},
	weaponType: {
		label: "Was möchten Sie in Ihrem Waffenschrank lagern?",
		answers: [
			{
				label: "Lang- und Kurzwaffen",
				icon: LangKurzWaffen,
				description:
					"Langwaffenschränke für die Aufbewahrung von Langwaffen wie Gewehre oder Flinten - auch geeignet für Kurzwaffen.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-langwaffenschrank"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "numberOfWeapons",
			},
			{
				label: "Kurzwaffen",
				icon: Kurzwaffen,
				description:
					"Kurzwaffentresore speziell geeignet für Handfeuerwaffen wie Pistolen oder Revolver.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-kurzwaffentresor"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Munition",
				icon: Munition,
				description:
					"Munitionsschränke für die sichere Aufbewahrung von Munition und Zubehör ohne jegliche Waffen.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-munitionsschrank"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: null,
			},
		],
	},
	numberOfWeapons: {
		label: "Wie viele Waffen möchten Sie in Ihrem Waffenschrank lagern?",
		answers: [
			{
				label: "1-5",
				icon: LangKurzWaffen,
				description: "Für die Aufbewahrung von bis zu 5 Langwaffen.",
				searchState: {
					range: {
						numberOfWeaponFixtures: {
							min: 1,
							max: 5,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "6-10",
				icon: LangKurzWaffen,
				description: "Für die Aufbewahrung von bis zu 10 Langwaffen.",
				searchState: {
					range: {
						numberOfWeaponFixtures: {
							min: 6,
							max: 10,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "10+",
				icon: LangKurzWaffen,
				description: "Für die Aufbewahrung von mehr als 10 Langwaffen.",
				searchState: {
					range: {
						numberOfWeaponFixtures: {
							min: 10,
							max: 100,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	keySafeType: {
		label: "Worin möchten Sie Ihre Schlüssel lagern?",
		answers: [
			{
				label: "Schlüsselkästen",
				icon: Schluesselkaesten,
				description:
					"Unzertifizierte Schlüsselkästen sind ideal um auch große Mengen an Schlüsseln übersichtlich zu organisieren, bieten aber nur geringen Einbruchschutz.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-schluesselkasten"],
					},
				},
				nextQuestionId: "numberOfKeys",
			},
			{
				label: "Schlüsseltresore",
				icon: Schluesseltresore,
				description:
					"Zertifizierte Schlüsseltresore sind in vielen Sicherheitsstufen erhältlich und schützen gelagerte Schlüssel zuverlässig.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-schluesselsafe"],
						securityGrade: [
							"A nach VDMA 24992",
							"B nach VDMA 24992",
							"S1 nach EN 14450",
							"S2 nach EN 14450",
							"0 nach EN 1143-1",
							"1 nach EN 1143-1",
						],
					},
				},
				nextQuestionId: "numberOfKeys",
			},
			{
				label: "Schlüsselmanagementsysteme",
				icon: Schluesselmanagement,
				description:
					"Innovative elektronische und mechanische Systeme um Schlüssel effektiv zu verwalten.",
				searchState: {
					refinementList: {
						categoryIds: ["tre-schluesselverwaltung"],
					},
				},
				nextQuestionId: null,
			},
		],
	},
	numberOfKeys: {
		label: "Wie viele Schlüssel wollen Sie aufbewahren?",
		answers: [
			{
				label: "bis zu 100",
				icon: Schluessel,
				description: "Ausstattung mit bis zu 100 Schlüsselhaken.",
				searchState: {
					range: {
						numberOfKeyHooks: {
							min: 1,
							max: 100,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "101 bis 250",
				icon: Schluessel,
				description: "Ausstattung mit bis zu 250 Schlüsselhaken.",
				searchState: {
					range: {
						numberOfKeyHooks: {
							min: 101,
							max: 250,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "251 bis 500",
				icon: Schluessel,
				description: "Ausstattung mit bis zu 500 Schlüsselhaken.",
				searchState: {
					range: {
						numberOfKeyHooks: {
							min: 251,
							max: 500,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "501 bis 1000",
				icon: Schluessel,
				description: "Ausstattung mit bis zu 1000 Schlüsselhaken.",
				searchState: {
					range: {
						numberOfKeyHooks: {
							min: 501,
							max: 1000,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "mehr als 1000",
				icon: Schluessel,
				description: "Ausstattung mit mehr als 1000 Schlüsselhaken.",
				searchState: {
					range: {
						numberOfKeyHooks: {
							min: 1001,
							max: 10000,
						},
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	valueProtectionCertified: {
		label: "Soll Ihr neuer Tresor einen zertifizierten Einbruchschutz bieten?",
		answers: [
			{
				label: "Basis Einbruchschutz",
				icon: GuterSchutz,
				description: "Unzertifizierter Einbruchschutz - keine Versicherbarkeit gegeben.",
				searchState: {
					refinementList: {
						securityGrade: ["keine"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
			{
				label: "Zertifizierter Einbruchschutz",
				icon: PremiumSchutz,
				description:
					"Zertifizierter Einbruchschutz - unterschiedliche Stufen für unterschiedlich hohe Versicherungssummen.",
				searchState: {
					refinementList: {
						securityGrade: [
							"A nach VDMA 24992",
							"B nach VDMA 24992",
							"S1 nach EN 14450",
							"S2 nach EN 14450",
							"0 nach EN 1143-1",
							"1 nach EN 1143-1",
							"2 nach EN 1143-1",
							"3 nach EN 1143-1",
							"4 nach EN 1143-1",
							"4KB nach EN 1143-1",
							"5 nach EN 1143-1",
							"5KB nach EN 1143-1",
							"6 nach EN 1143-1",
						],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "lockType",
			},
		],
	},
	dataFireProtectionType: {
		label: "Welchen Schutz soll Ihr neuer Datentresor bieten?",
		answers: [
			{
				label: "Basis Brandschutz",
				icon: BasisBrandschutz,
				description:
					"Zertifizierter Brand- und Hitzeschutz für Datenträger bis zu 60 Minuten.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["30 Minuten Datenträger", "60 Minuten Datenträger"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "valueProtectionCertified",
			},
			{
				label: "Guter Brandschutz",
				icon: GuterBrandschutz,
				description:
					"Zertifizierter Brand- und Hitzeschutz für Datenträger bis zu 90 Minuten.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["90 Minuten Datenträger"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "valueProtectionCertified",
			},
			{
				label: "Sehr guter Brandschutz",
				icon: PremiumBrandschutz,
				description:
					"Zertifizierter Brand- und Hitzeschutz für Datenträger bis zu 180 Minuten.",
				searchState: {
					refinementList: {
						fireSafetyGrade: ["120 Minuten Datenträger", "180 Minuten Datenträger"],
					},
					sortBy: "products_price_asc",
				},
				nextQuestionId: "valueProtectionCertified",
			},
		],
	},
	// shelfOrDrawer: {
	// 	label: "Benötigen Sie Fachböden oder Schubladen?",
	// 	answers: [
	// 		{
	// 			label: "Fachböden",
	// 			icon: Wertgegenstände,
	// 			searchState: {},
	// 			nextQuestionId: "lockType",
	// 		},
	// 		{
	// 			label: "Schubladen",
	// 			icon: Wertgegenstände,
	// 			searchState: {},
	// 			nextQuestionId: "lockType",
	// 		},
	// 	],
	// },
}

export default questionsByQuestionId
